import { ManageUsersState } from '../interface/MyInterfaces'

export default function (state: ManageUsersState = { Message: "" }, action) {

    switch (action.type) {
        case "LOAD_USERS":
            var propertyName = "UserList";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "DISABLE_USER":
            var userInfo = action.payload;
            var newState = Object.assign({}, state);
            var theList = newState["UserList"];
            var theIndex = theList.findIndex(x => x.username == userInfo.username);

            theList[theIndex].activeFlag = userInfo.value;
            newState["UserList"] = theList;
            newState["Message"] = "User was updated successfully.";
            return newState;

        case "SET_ADMINISTRATOR":
            var userInfo = action.payload;
            var newState = Object.assign({}, state);
            var theList = newState["UserList"];
            var theIndex = theList.findIndex(x => x.username == userInfo.username);

            theList[theIndex].administrator = userInfo.value;
            newState["UserList"] = theList;
            newState["Message"] = "User was updated successfully.";
            return newState;

        case "SEND_PASSWORD_RESET_EMAIL":
            propertyName = "Message";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            return newState;

        case "ADD_NEW_USER":
            var newState = Object.assign({}, state);
            var theList = newState["UserList"];
            theList.push(action.payload);
            newState["UserList"] = theList;
            newState["Message"] = "New User was added successfully.";
            return newState;
        case "CLEAR_MESSAGE":
            var propertyName = "Message";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            return newState;
        default:
            return state;
    }
}